import React from "react"
import Pill from "components/elements/Pill"

interface Props {
  groupSize: number
  childGuest: boolean
}

const GroupLabel = ({ groupSize, childGuest }: Props) => (
  <Pill
    color={childGuest ? "gray.100" : "teal.300"}
    borderWidth={1}
    textColor={childGuest ? "teal.300" : undefined}
    borderColor="teal.300"
    label={`Group of ${groupSize}`}
    width="auto"
    px={2}
  />
)

export default GroupLabel
